'use client';

import React from 'react';
import SlideWrapper from '../SlideWrapper';
import { Building2 } from 'lucide-react';

interface Props {
  id: string;
  registerRef: (id: string, el: HTMLElement | null) => void;
}

export default function Slide17SchoolValue({ id, registerRef }: Props) {
  const cards = [
  {
    title: 'Có sẵn một chương trình được thiết kế bài bản',
    desc: 'Nhà trường không cần bắt đầu từ con số 0. Tri An Green Travel đã chuẩn bị sẵn khung chương trình, logic hoạt động và hệ thống quyền lợi đi kèm, giúp giảm đáng kể thời gian và áp lực trong khâu lên ý tưởng, tổ chức và truyền thông.'
  },
  {
    title: 'Nội dung phù hợp với định hướng phát triển sinh viên',
    desc: 'Chương trình đáp ứng tốt các mục tiêu mà nhiều trường đang hướng tới như phát triển sinh viên toàn diện, tăng trải nghiệm thực tế, rèn kỹ năng mềm, nâng cao trách nhiệm xã hội và lan tỏa lối sống xanh tích cực.'
  },
  {
    title: 'Có hình ảnh đẹp để truyền thông',
    desc: 'Vì chương trình có hoạt động thật, bối cảnh thật và cảm xúc thật nên rất thuận lợi cho truyền thông. Nhà trường sẽ có thêm hình ảnh đẹp, khoảnh khắc thật và nhiều chất liệu tích cực để truyền thông tới sinh viên và cộng đồng.'
  },
  {
    title: 'Có video recap và tư liệu truyền thông sau chương trình',
    desc: 'Nhà trường / Đoàn – Hội có thể sử dụng video recap, ảnh hoạt động, ảnh tập thể và các tư liệu truyền thông tổng hợp để đăng tải trên fanpage, website trường, khoa, CLB hoặc các kênh nội bộ.'
  }];


  return (
    <SlideWrapper id={id} registerRef={registerRef} className="bg-[#f5f0e8]">
      <div className="absolute inset-0 z-0">
        <img
          src="https://img.rocket.new/generatedImages/rocket_gen_img_1e3378930-1768009592936.png"
          alt="Sinh viên đại học tham gia hoạt động ngoại khóa sôi nổi trên khuôn viên trường, không khí vui tươi"
          className="w-full h-full object-cover opacity-8" />

        <div className="absolute inset-0 bg-[#f5f0e8]/90" />
      </div>
      <div className="relative z-10 max-w-screen-xl mx-auto px-6 lg:px-16 xl:px-24 py-20 min-h-screen flex flex-col justify-center">
        <div className="fade-in-up mb-3">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[rgba(26,74,42,0.1)] border border-[rgba(26,74,42,0.2)] mb-4">
            <Building2 size={12} className="text-[#1a4a2a]" />
            <span className="text-[11px] font-700 uppercase tracking-widest text-[#1a4a2a] font-body">Dành cho nhà trường / Đoàn – Hội</span>
          </div>
          <h2 className="font-display font-800 text-[clamp(26px,4vw,52px)] leading-[1.1] text-[#1a4a2a] tracking-tight">
            Quyền lợi dành cho nhà trường / Đoàn – Hội
          </h2>
        </div>

        <div className="fade-in-up mb-10">
          <p className="font-body text-[15px] text-[#3a5a3a] leading-relaxed">
            Khi đồng hành cùng Tri An Green Travel, nhà trường và Đoàn – Hội sẽ có thêm nhiều giá trị rõ ràng:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 fade-in-up">
          {cards.map((card, i) =>
          <div
            key={`school17-${i}`}
            className="rounded-2xl bg-[rgba(200,220,200,0.35)] border border-[rgba(26,74,42,0.12)] p-7 flex flex-col transition-all duration-300 hover:-translate-y-1 hover:shadow-md">

              <h3 className="font-display font-700 text-[17px] text-[#1a4a2a] mb-3 leading-snug">{card.title}</h3>
              <p className="font-body text-[14px] text-[#3a5a3a] leading-relaxed">{card.desc}</p>
            </div>
          )}
        </div>
      </div>
    </SlideWrapper>);

}